import React, { useEffect } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  // title?: string
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      {/* Backdrop click to close */}
      <div
        className="absolute inset-0"
        onClick={onClose}
        role="button"
        aria-label="Close modal"
      />

      {/* Modal content */}
      <div className="relative w-[60%] rounded-2xl bg-white  transition-all duration-300 ease-out scale-100">
        {/* {title && (
          <h2 className="mb-4 text-lg font-semibold text-gray-800">{title}</h2>
        )} */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
